import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/lang/locales/en-US'
import axios from 'axios'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages: {
    'en-US': messages
  },
  silentTranslationWarn: true
})

const loadedLanguages = ['en-US']

export const languages = {
  'en-US': 'English',
  'de': 'Deutch',
  'es': 'Español',
  'ro': 'Română',
  'zh-HK': '香港'
}

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function isLang (lang) {
  return i18n.locale === lang
}

export function loadLanguageAsync (lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `@/lang/locales/${lang}`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      }).catch((e) => console.warn('Language not supported'))
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}



// WEBPACK FOOTER //
// ./src/lang/lang.js